import './custom.scss'
import './bootstrap_custom.scss'

import 'bootstrap'

import './tinymce'

import 'air-datepicker/dist/css/datepicker.min.css'
import 'air-datepicker/dist/js/datepicker'
import 'air-datepicker/dist/js/i18n/datepicker.es'
import 'magnific-popup/dist/jquery.magnific-popup'
import 'magnific-popup/dist/magnific-popup.css'

import '@mdi/font/css/materialdesignicons.css'


console.log('Payload loaded!')